import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import {
  ICreateManualGstPayout,
  ICreateManualPayout,
} from "@shared/lib/types/briefCampains";
import { FINANCE_INFLUENCER_QUERY_KEY, PAYOUTS_QUERY_KEY } from "../contsants";

export function useCreateManualGstPayout(campaignInfluencerId: string) {
  const {
    mutate: createManualGstPayout,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<ICreateManualGstPayout>({
    mutationFn: async (payout) => {
      return await CampaignService.createManualGstPayout(payout).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      c.invalidateQueries({
        queryKey: [...PAYOUTS_QUERY_KEY()],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    createManualGstPayout,
    isCreating,
    isCreated,
  };
}
